import React, { useMemo } from 'react';

import BottomSheet from 'components/BottomSheet';
import Shimmer from 'components/Shimmer';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { VehicleOption } from 'models/auto/vehicle';

import AutoAgency, { LoadingAutoAgency } from './components/AutoAgency';
import { Container, Header, Close, List, Item } from './styles';

export interface Props {
  onClose: () => void;
  show: boolean;
  onSelect: (option: VehicleOption) => void;
  agencies?: VehicleOption[];
  selectedVehicle?: VehicleOption;
  isLoading?: boolean;
  isPickUp?: boolean;
}

const LoadingAutoAgencies = () => (
  <>
    <Header>
      <div>
        <Header.Title>
          <Shimmer>Lista de agências</Shimmer>
        </Header.Title>
        <Header.Sub>
          <Shimmer>Seleciona a agência mais próxima</Shimmer>
        </Header.Sub>
      </div>
    </Header>
    <List>
      {[...Array(2).keys()].map((index) => (
        <Item key={index}>
          <LoadingAutoAgency />
        </Item>
      ))}
    </List>
  </>
);
const AutoAgencies = ({
  onClose,
  show,
  onSelect,
  agencies,
  selectedVehicle,
  isLoading = false,
  isPickUp = true,
}: Props) => {
  const { t } = useStoreTranslation();

  const uniqueAgencies = useMemo(() => {
    if (!agencies) return [];
    const seen = new Set<string>();
    const selectedKey = isPickUp ? selectedVehicle?.pickUp?.address : selectedVehicle?.dropOff?.address;
    if (selectedKey) seen.add(selectedKey);
    return agencies.reduce<VehicleOption[]>((acc, vehicle) => {
      const key = isPickUp ? vehicle.pickUp?.address : vehicle.dropOff?.address;
      if (!key || seen.has(key)) return acc;
      seen.add(key);
      return [...acc, vehicle];
    }, []);
  }, [agencies, isPickUp, selectedVehicle]);

  return (
    <BottomSheet show={show} onClose={onClose} noHeader>
      <Container>
        {isLoading ? (
          <LoadingAutoAgencies />
        ) : (
          <>
            <Header>
              <div>
                <Header.Title>{t('autosDetails.agencies.title')}</Header.Title>
                <Header.Sub>{t('autosDetails.agencies.description')}</Header.Sub>
              </div>
              <Close onClick={onClose}>
                <Close.Icon />
              </Close>
            </Header>
            {agencies && agencies.length > 0 ? (
              <List>
                {selectedVehicle ? (
                  <Item>
                    <AutoAgency vehicle={selectedVehicle} isPickUp={isPickUp} isSelected={true} />
                  </Item>
                ) : null}
                {uniqueAgencies.map((vehicle, idx) => (
                  <Item key={idx} onClick={() => onSelect(vehicle)}>
                    <AutoAgency vehicle={vehicle} isPickUp={isPickUp} isSelected={false} />
                  </Item>
                ))}
              </List>
            ) : null}
          </>
        )}
      </Container>
    </BottomSheet>
  );
};

export default AutoAgencies;
